// import { IServiceStatus } from 'interfaces/service'

import { IType } from './implement';

// BE đã xác nhận để key thuần text (Dương Khánh Nghĩa)
export enum EServiceStatus {
  // CREATED = 'Khởi tạo',
  // WAITING_FOR_BUSINESS_APPROVE = 'Chờ KD duyệt',
  // OPENED = 'Mở lại hồ sơ',
  // BUSINESS_REJECTED = 'KD từ chối',
  // WAITING_FOR_RECONCILE_APPROVE = 'Chờ ĐS duyệt',
  // RECONCILE_REJECTED = 'ĐS từ chối',
  ACTIVATED = 'Hoạt động',
  // LOCKED = 'Khóa',
  INIT = 'Khởi tạo',
  WAITING_TO_APPROVE = 'Chờ ĐS duyệt',
  APPROVED = 'ĐS duyệt',
  REOPEN = 'Mở lại HS',
}

// export const SERVICE_STATUS: { [key: string]: IServiceStatus } = {
//   [EServiceStatus.CREATED]: {
//     text: 'Khởi tạo',
//     code: EServiceStatus.CREATED,
//     color: '',
//   },
//   [EServiceStatus.WAITING_FOR_BUSINESS_APPROVE]: {
//     text: 'Chờ kinh doanh duyệt',
//     code: EServiceStatus.WAITING_FOR_BUSINESS_APPROVE,
//     color: '#9900ff',
//   },
//   [EServiceStatus.OPENED]: {
//     text: 'Mở lại hồ sơ',
//     code: EServiceStatus.OPENED,
//     color: '#ffff00',
//   },
//   [EServiceStatus.BUSINESS_REJECTED]: {
//     text: 'Kinh doanh từ chối',
//     code: EServiceStatus.BUSINESS_REJECTED,
//     color: '#cc0000',
//   },
//   [EServiceStatus.WAITING_FOR_RECONCILE_APPROVE]: {
//     text: 'Chờ đối soát duyệt',
//     code: EServiceStatus.WAITING_FOR_RECONCILE_APPROVE,
//     color: '46bdc6',
//   },
//   [EServiceStatus.RECONCILE_REJECTED]: {
//     text: 'Đối soát từ chối',
//     code: EServiceStatus.RECONCILE_REJECTED,
//     color: '#cc0000',
//   },
//   [EServiceStatus.ACTIVATED]: {
//     text: 'Hoạt động',
//     code: EServiceStatus.ACTIVATED,
//     color: '#30CD60',
//   },
//   [EServiceStatus.LOCKED]: {
//     text: 'Khóa',
//     code: EServiceStatus.LOCKED,
//     color: '#434343',
//   },
// };

export enum EService {
  QR = 'QR',
  CTT = 'CTT',
  SPOS = 'SPOS',
  POS365 = 'POS365',
  SAPO = 'SAPO',
  SALE_MACHINE = 'BANMAY',
}

export const QR_TYPE = 'QR offline';
export const PROVIDER = '0241';
export const MAX_LENGTH_TERMINAL_CODE = 8;

export const PAYMENT_SOURCE = {
  INLAND: 'Nội địa',
  GLOBAL: 'Quốc tế',
};

export const SERVICE_NOPAY: IType = {
  POS365: {
    label: 'POS365',
    value: 1,
  },
  SAPO: {
    label: 'SAPO',
    value: 2,
  },
  SALE_MACHINE: {
    label: 'Bán máy',
    value: 3,
  },
};

export const SERVICES_ITEMS_PARTNER_SP = [
  { id: 3, name: 'SPOS', code: 'SPOS' },
];
export const BANK_ITEMS_PARTNER_SP = [
  { id: 49, name: 'Nam A Bank', code: '970439', brand: 'NAMABANK' },
];
